(function($){

    // Mobile menu
    $('.header-menu').on('click keypress', function(){
        $(this).toggleClass('open')
        $('.header, .header-top, .logo').toggleClass('menu-active')
        $('.mobile_menu').toggleClass('active')
        if($(this).hasClass('open')){
            $('.accordion-menu a, .accordion-menu button').removeAttr('tabindex')   
            lockScroll() 
        } else { 
            $('.accordion-menu a, .accordion-menu button').attr('tabindex', "-1")
            unlockScroll()
        }
        
    })

    // Lock body scroll when mobile menu is open
    function lockScroll(){
        document.body.style.overflow = 'hidden';
    }
    function unlockScroll(){
        document.body.style.overflow = '';
    }
 

    $(window).on('resize', function(){
        if($(window).width() > 1179){
            $('.header-menu').removeClass('open')
            $('.header, .header-top, .logo').removeClass('menu-active')
            $('.mobile_menu').removeClass('active')
            $('.accordion-menu a, .accordion-menu button').attr('tabindex', "-1")
        }
    })

    $('.search-button').on('click keypress', function(){
        $('.search-bar').toggleClass('active')
        if($('.search-bar').hasClass('active')){
            $('.search-field, .search-submit').removeAttr('tabindex')    
        } else {
            $('.search-field, .search-submit').attr('tabindex', "-1")
        }
    })
    
    // Cookie functions
    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==" ") c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function eraseCookie(name) {   
        document.cookie = name+"=; Max-Age=-99999999;";  
    }

    $('.accordion-menu a, .accordion-menu button').attr('tabindex', "-1")


})(jQuery);

const covValidateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };